var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgButtonPause = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 10 14"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 3.31,
  height: 13.241,
  x: 0.07,
  y: 0.379,
  fill: "currentColor",
  rx: 1.655
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 3.31,
  height: 13.241,
  x: 6.691,
  y: 0.379,
  fill: "currentColor",
  rx: 1.655
})));
export default SvgButtonPause;